import {useState,useEffect,useRef} from "react";
import ImageWithBasePath from "../../../core/img";
import Slider from "react-slick";
import {Link,useNavigate} from "react-router-dom";
import {all_routes} from "../../router/all_routes";
import {Rating} from 'react-simple-star-rating';
/* -- biz9 import start -- */
import {Log,Num,Str,DateTime} from "biz9-utility";
import {Field,Message,Title,Type,Url} from "../../../constant";
import {App,Data,Dashboard,Event,Field_Logic,Image,Style,Service_Industry,Template,Toast_Message,Storage,System,User} from "../../../project";
import {User_Logic} from "biz9-user";
import {Review_Url,Review_Logic} from "biz9-review";
/* -- biz9 import end -- */
const Review_Edit = () => {
    const alert_prop = useRef(null);
    const timeoutRef = useRef(null);
   	const [user,setUser] = useState(User.get());
    const [val_review_rating,setValReviewRating] = useState(0)
    const [val_review_title,setValReviewTitle] = useState(!user.is_guest ? "Title " + Num.get_id() : "Please Login In");
    const [val_review_name,setValReviewName] = useState(user ? user.title : "Please Login In");
    const [val_review_location,setValLocation] = useState(user ? User_Logic.get_country_state_city(user) :"" );
    const [val_review_comment,setValReviewComment] = useState("");
    async function btn_post(){
        //let review = Review_Logic.get(Portal_Table.PRODUCT,'1',user.id,val_review_title,val_review_comment,val_review_rating);
        //let [response,data] = await Portal_Remote_Data.post(App.get_url(Portal_Url.DATA_POST),Portal_Table.PRODUCT,{parent_id:1,review:review});
        //Toast_Message.success(response.message);


    };
    const updateValReviewTitle = (event) => {
        setValReviewTitle(event.target.value);
    };
    const updateValReviewComment = (event) => {
        setValReviewComment(event.target.value);
    };
    const updateValReviewRating = (val: number) => {
        setValReviewRating(val)
    }
    return (
            <>
            {/* Breadcrumb */}
            <div className="breadcrumb-bar breadcrumb-bar-info">
            <div className="breadcrumb-img">
            <div className="breadcrumb-left">
            <ImageWithBasePath src="/assets/img/bg/banner-bg-03.png" alt="img" />
            </div>
            </div>
            <div className="container">
            <div className="row">
            <div className="col-md-12 col-12">
            <h2 className="breadcrumb-title mb-0">
            Testimonials <span className="text-primary" />
            </h2>
            </div>
            </div>
            </div>
            </div>
            {/* /Breadcrumb */}
    {/* Content */}
        <div className="page-content content">
        <div className="container">
        <div className="login-card">
        <div className="login-heading text-start mb-4">
        <h5>Leave a Review</h5>
        </div>
        <div className="form-wrap form-focus">
        <label className="mb-1 fw-medium text-dark mb-1">
        Your Rating <span className="text-primary">*</span>
        </label>
        <Rating className="mb-1 fw-medium text-dark mb-1" onClick={updateValReviewRating} initialValue={val_review_rating} />
        </div>
        <div className="row">
        <div className="col-lg-12">
        <div className="form-wrap form-focus">
        <label className="mb-1 fw-medium text-dark">Title <span className="text-primary">*</span>  </label>
        <input value={val_review_title}  disabled={user.is_guest? true: false} onChange={updateValReviewTitle} type="text" className="form-control"/>
        </div>
        </div>
        <div style={{ display: user.is_guest ? 'none' : 'block' }} className="col-lg-6">
        <div className="form-wrap form-focus">
        <label className="mb-1 fw-medium text-dark">
        Name <span className="text-primary">*</span>
        </label>
        <input value={val_review_name} disabled={true} type="text" className="form-control" />
        </div>
        </div>
        <div  style={{ display: user.is_guest ? 'none' : 'inline' }} className="col-lg-6">
        <div className="form-wrap form-focus">
        <label className="mb-1 fw-medium text-dark">
        {" "}
    Location <span className="text-primary">*</span>
        </label>
        <input value={val_review_location} disabled={true} type="text" className="form-control" />
        </div>
        </div>
        <div style={{ display: user.is_guest ? 'none' : 'inline' }} className="col-lg-12">
        <div className="form-wrap form-focus">
        <label className="mb-1 fw-medium text-dark">
        {" "}
    Write a Review <span className="text-primary">*</span>
        </label>
        <textarea  value={val_review_comment} className="form-control text-area" defaultValue={""} />
        </div>
        </div>
        </div>
        <Link style={{ display: user.is_guest ? 'none' : 'inline' }} onClick={() => btn_post()} to="#" className="btn btn-primary member-btn">
        {" "}
    Submit a Review{" "}
    </Link>
        <Link to="#" className="btn">
        </Link>
        </div>
        {/* /Review Tags */}
    </div>
        </div>
        {/* /Content */}
    </>
        )
}
export default Review_Edit
